<template>
  <div class="page_container">
    <SingleClassroomHeader
      :classroomDetail="classroomDetail"
      :liveTotalCount="videoTotalCount"
      @searchVideoList="searchVideoList"
    />
    <div class="live-list">
      <LiveList
        :searchVideoListValue="searchVideoListValue"
        @updateVideoList="updateVideoList"/>
    </div>
    <div class="inspection-status">
      <InspectionStatus />
    </div>

  </div>
</template>

<script>
import SingleClassroomHeader from './comp/SingleClassroomHeader'
import InspectionStatus from './comp/InspectionStatus'
import LiveList from './comp/LiveList'

const defaultIcon = require('@/assets/img/icon-empty-box@2x.png')
export default {
  name: 'HistoricalReplay',
  components: {
    SingleClassroomHeader,
    InspectionStatus,
    LiveList
  },
  data () {
    return {
      defaultIcon,
      classroomDetail: {},
      videoTotalCount: 0, // 直播总次数
      searchVideoListValue: {} // 搜索参数
    }
  },
  async created() {
    const { classroomCode } = this.$route.query
    if (!classroomCode) return this.$router.go(-1)
    await this.getClassroomInspectionDetail()
  },
  methods: {
    searchVideoList(obj) {
      this.searchVideoListValue = obj
    },
    updateVideoList(obj) {
      this.videoTotalCount = obj.videoTotalCount
    },
    // 单教室详情
    async getClassroomInspectionDetail () {
      try {
        const { classroomCode } = this.$route.query
        const params = {
          classroomCode
        }
        const result = await this.$http.classroomInspectionDetail(params)
        if (result.code !== 200) return
        this.classroomDetail = result.rt || {}
      } catch (err) {
        console.log('单教室详情err', err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .page_container {
    width: 100%;
    height: 100%;

    padding: 16px 0 16px 16px;
    background-color: #F6F8FA;
    .live-list{
      // min-height: 192px;
      padding: 16px;
      background: #fff;
      margin-bottom: 16px;
      box-shadow: 0px 2px 6px 0px rgba(1,22,43,0.08);
    }
    .inspection-status{
      padding: 16px 16px 1px;
      box-shadow: 0px 2px 6px 0px rgba(1,22,43,0.08);
      background: #fff;
      // min-height: 192px;
    }
  }
</style>